goog.module('yext.spark.admin.Table');
goog.module.declareLegacyNamespace();

/**
 * @constructor
 *
 * @param {!jQuery} table The table element
 * @param {string} ajaxUrl The path of the endpoint used in the ajax search request
 * @param {number} defaultSortColumn The column to sort by on initial page load
 * @param {array} unsortableColumns list of column numbers that should have sorting disabled
 */
const Table = function($table, ajaxUrl, defaultSortColumn, unsortableColumns) {
  this.$table = $table;
  this.ajaxUrl = ajaxUrl;
  this.defaultSortColumn = typeof defaultSortColumn === 'undefined' ? 0 : defaultSortColumn;
  this.unsortableColumns = typeof unsortableColumns === 'undefined' ? [] : unsortableColumns;
  this.bind();
};

/**
 * Binds the table as a jQuery DataTable object.
 *
 * @param {string} ajaxSource The path of the endpoint used in the ajax request
 */
Table.prototype.bind = function() {
  this.$table.dataTable({
    'bJQueryUI': true,
    'bProcessing': true,
    'bFilter': false,
    'sPaginationType': 'full_numbers',
    'oLanguage': {
      'sLengthMenu': 'Show _MENU_ Pages',
      'sInfo': 'Showing _START_ to _END_ of _TOTAL_ Items',
      'sInfoFiltered': '',
    },
    'aLengthMenu': [[25, 50, 100], [25, 50, 100]],
    'sDom': '<"H"lT>rt<"F"ip>',
    'iDisplayLength': 25,
    'sAjaxSource': this.ajaxUrl,
    'bServerSide': true,
    'aoColumnDefs': [{'bSortable': false, 'aTargets': this.unsortableColumns}],
    'aaSorting': [[this.defaultSortColumn, 'desc']],
  });
};

goog.exportSymbol('yext.spark.admin.Table', Table);

exports = Table;
